module.exports = __webpack_public_path__ + "img/warning.0cf2f30b.svg";